
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAPICall } from '../../hooks/useAPICall';
import '../../css/main.css';



export function ForgotPasswordForm() {



  const { MakeCall } = useAPICall();

function handleResetComplete()
{
    document.getElementById("userdetails").style.display = 'none';
    document.getElementById("resulttext").style.display = 'block';
}

function handleRequestReset()
{
    let url = "{ \"username\" : \"" + document.getElementById("email").value + "\"}";
    MakeCall('member/requestpasswordreset', "{ \"username\" : \"" + document.getElementById("email").value + "\"}", handleResetComplete, true);
    
}

  return (
    <>
      <div className='loginwindow'>
        <div className='loginform' id='userdetails'>
          <div className='titlediv'>PRC Membership Fogotten Password</div>
          <div style={{width: "100%"}}>
            <div>
                Please enter your email, if you have a user you will receive an email with a reset link.
            </div>
            <div className='labeldiv'>
              <label>Username</label>
            </div>
            <div>
              <input className='logininput' placeholder='username' id='email' type='email'></input>
            </div>           
            <div className='buttondiv' style={{paddingTop : "25px"}}>
              <button className='prcbtn' type='button' onClick={handleRequestReset}>Change Password</button>
            </div>
          </div>
        </div>
        <div className='loginform' id='resulttext' style={{"display":"none"}}>
            <p>If your have a user, then an email has been sent with password reset instructions. If you do not receive it in the next few minutes, please check your spam folder.</p>           
        </div>
      </div>
      </>

  );
}


